module.exports = __webpack_public_path__ + "img/fastfood.b852ad2a.png";